// extracted by mini-css-extract-plugin
export default {"cardSpacing":"BGqBWp3IJ3nucBZCeqBh"};